import { render, staticRenderFns } from "./AbsenceChips.vue?vue&type=template&id=76e4388c"
import script from "./AbsenceChips.vue?vue&type=script&lang=js"
export * from "./AbsenceChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports